/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tools found — try another spelling.`)
};

const es_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron herramientas — prueba con otra ortografía.`)
};

const de_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Tools gefunden — versuchen Sie eine andere Schreibweise.`)
};

const nl_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen tools gevonden — probeer een andere spelling.`)
};

const fr_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun outil trouvé — essayez une autre orthographe.`)
};

const it_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno strumento trovato — prova un'altra ortografia.`)
};

const pt_br2_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma ferramenta encontrada — tente outra grafia.`)
};

const pt_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma ferramenta encontrada — tente outra grafia.`)
};

const ja_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールが見つかりませんでした。別のスペルをお試しください。`)
};

const zh_search_no_results = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到相关工具 — 请尝试其他拼写。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search_no_results = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_no_results(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("search_no_results", locale)
	if (locale === "en") return en_search_no_results(inputs)
	if (locale === "es") return es_search_no_results(inputs)
	if (locale === "de") return de_search_no_results(inputs)
	if (locale === "nl") return nl_search_no_results(inputs)
	if (locale === "fr") return fr_search_no_results(inputs)
	if (locale === "it") return it_search_no_results(inputs)
	if (locale === "pt-BR") return pt_br2_search_no_results(inputs)
	if (locale === "pt") return pt_search_no_results(inputs)
	if (locale === "ja") return ja_search_no_results(inputs)
	return zh_search_no_results(inputs)
};